import { useCallback } from "react";
import type { MouseEvent } from "react";
import { useAgentProfileDrawer } from "@/react/components/Drawers/AgentProfileDrawer";
import { getAgentProfileLinkProps } from "@circle-react/helpers/agentHelpers";
import { isIntendedOnNewTab } from "@circle-react/helpers/browserHelpers";
import type { ParamsShape } from "@circle-react/helpers/profileHelpers";
import { useIsIframeEmbed } from "@circle-react/hooks/useIsIframeEmbed";
import { useRailbar } from "../chatsV2";

export interface UseAgentProfileLinkPropsArgs {
  id: number;
  name?: string;
  params?: ParamsShape;
}

export const useAgentProfileLinkProps = ({
  name,
  params = {},
  id,
}: UseAgentProfileLinkPropsArgs) => {
  const agentDrawer = useAgentProfileDrawer();
  const showAgentProfileDrawer = agentDrawer.show;
  const isIframeEmbed = useIsIframeEmbed();
  const { isDrawer } = useRailbar();

  const handleLinkClick = useCallback(
    (event: MouseEvent<HTMLElement>) => {
      const shouldOpenInNewTab =
        isIntendedOnNewTab(event) || isIframeEmbed || isDrawer;
      if (!shouldOpenInNewTab) {
        event.preventDefault();
        void showAgentProfileDrawer({ agentId: id, params });
      }
    },
    [isIframeEmbed, isDrawer, params, showAgentProfileDrawer],
  );

  return {
    ...getAgentProfileLinkProps({
      name,
      params,
      agentId: id,
      shouldOpenInNewTab: isIframeEmbed,
      showAgentProfileDrawer: showAgentProfileDrawer,
    }),
    onClick: handleLinkClick,
  };
};
